import { css } from 'astroturf';
import React from 'react';

const styles = css`
  .typeBadge {
    width: 28px;
    height: 18px;
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    border-radius: 3px;
    padding: 1px 2px;
    line-height: 1;
    letter-spacing: 0;
    text-align: end;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    background: var(--background);
    color: var(--text-color-secondary);
    flex-shrink: 0;
    z-index: 1;

    position: absolute;
    top: 1rem;
    right: 1rem;

    color: #39728d;
  }

  .css {
    background: rebeccapurple;
    color: white;
  }

`;

export function CollectionIcon() {
  return (
    <span className={styles.typeBadge}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="icon icon-tabler icons-tabler-outline icon-tabler-folder"
      >
        <path d="M5 4h4l3 3h7a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2" />
      </svg>
    </span>
  );
}
